import { Component, OnInit } from "@angular/core";
import { Validators, FormGroup, FormBuilder } from "@angular/forms";
import { ILogin } from "../../../interfaces/login";
import { TranslateService } from "@ngstack/translate";
import "src/app/enums/sound.enum";
import { ErrorsService } from "src/app/services/common/errors.service";
import { Router, ActivatedRoute } from "@angular/router";
import { AccountService } from "src/app/services/http/business/account/account.service";
import { HidService } from "src/app/services/common/hid.service";
import { Title } from "@angular/platform-browser";
import { environment } from "src/environments/environment";
import { MatDialog } from "@angular/material";
import { SelectHoldingComponent } from "./select-holding/select-holding.component";
import { IError } from "src/app/interfaces/error.interface";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.css"],
  providers: [ErrorsService]
})
export class LoginComponent implements OnInit {
  param: any;
  errorList: IError[] = [];
  errObject: any;
  returnUrl: string;
  errors = new Array();
  loginform: FormGroup;
  holdingList: any;

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    public translate: TranslateService,
    private errorService: ErrorsService,
    private hidService: HidService,
    private dialog: MatDialog,
    private titleService: Title,
    private accountService: AccountService
  ) { }

  ngOnInit() {
    this.titleService.setTitle(environment.siteTitle);
    this.returnUrl = this.route.snapshot.queryParams["returnUrl"] || "/student";
    this.loginform = this.fb.group({
      nationalCode: [
        null,
        Validators.compose([
          Validators.required,
          Validators.pattern("^[0-9]*$"),
          Validators.minLength(10),
          Validators.maxLength(12)
        ])
      ],
      password: [null, Validators.required]
    });
  }

  submitLogin(form: ILogin) {
    this.errors = new Array();
    var command = {
      nationalCode: form.nationalCode,
      password: form.password
    }
    this.accountService.login(command).subscribe(
      res => {
        const user: any = res;
        if (user) {
          localStorage.setItem("token", user.token);
          this.accountService.getUserInfo().subscribe(us => {
            this.dialog
              .open(SelectHoldingComponent, {
                width: "700px",
                data: us
              })
              .afterClosed()
              .subscribe(reh => {
                if (reh) {
                  //set holding
                  this.hidService.setHID(reh.HoldingEncryptCode);
                  this.hidService.setHIDName(reh.Title);
                  localStorage.setItem("userInfo", JSON.stringify(us));
                  if (localStorage.getItem("token"))
                    this.router.navigateByUrl(this.returnUrl);
                }
                else {
                  this.accountService.logout();
                }
              });
          });
        }
      },
      err => {
        // this.errObject = this.errorService.getError(err);
        // this.param = this.errorService.objectError(this.errObject);
        // this.errors = this.errorService.returnError(err);
        this.errorList = this.errorService.getErrorList(err.error);
      }
    );
  }
}
